import { render } from "./HeroiconsOutlineFolderAdd.vue?vue&type=template&id=9798bcea"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFolderAdd.vue"]])

export default __exports__